import { Anchor, Group, Text } from '@mantine/core'

export const Footer = () => {
  return (
    <Group justify="space-between" align="center">
      <div>
        <Text size="xs">&copy; BlueCard, Inc.</Text>
      </div>
      <div>
        <Text size="xs">Confidential</Text>
      </div>
      <Group gap="xs">
        <Anchor href="#" size="xs">
          Support
        </Anchor>
        <Anchor href="#" size="xs">
          Terms
        </Anchor>
        <Anchor href="#" size="xs">
          Privacy
        </Anchor>
      </Group>
    </Group>
  )
}
